var _desc, _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6, _rect5, _text7, _text8, _rect6, _text9, _text0, _rect7, _text1, _circle, _path, _rect8, _text10, _text11, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 384",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrated view of the Kawnter counter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A stylised product grid: category tabs with item counts, a search bar, and six product cards, each with an illustrated item, its category, price in pesos and remaining stock.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 384,
    rx: 10,
    fill: "#F4F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 100,
    height: 40,
    rx: 9,
    fill: "#4E9A92",
    stroke: "none",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 32,
    fontSize: 11,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "All products")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 45,
    fontSize: 9,
    fill: "#CFE8E3"
  }, "12 items")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 12,
    width: 100,
    height: 40,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 131,
    y: 32,
    fontSize: 11,
    fontWeight: 600,
    fill: "#14344B"
  }, "Drinks")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 131,
    y: 45,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "8 items")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 12,
    width: 100,
    height: 40,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 238,
    y: 32,
    fontSize: 11,
    fontWeight: 600,
    fill: "#14344B"
  }, "Foods")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 238,
    y: 45,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "3 items")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 12,
    width: 100,
    height: 40,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 32,
    fontSize: 11,
    fontWeight: 600,
    fill: "#14344B"
  }, "Snacks")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 45,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "4 items")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 12,
    width: 100,
    height: 40,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 32,
    fontSize: 11,
    fontWeight: 600,
    fill: "#14344B"
  }, "Candies")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 45,
    fontSize: 9,
    fill: "#9BAFBC"
  }, "0 items")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 62,
    width: 452,
    height: 34,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 84,
    fontSize: 11.5,
    fill: "#9BAFBC"
  }, "Search for a product\u2026")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 79,
    r: 5.5,
    fill: "none",
    stroke: "#9BAFBC",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 83 l4 4",
    stroke: "#9BAFBC",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 62,
    width: 78,
    height: 34,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 84,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE"
  }, "SORT BY")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 524,
    y: 84,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Name")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13,-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0,
    width: 20,
    height: 9,
    rx: 3,
    fill: "#1D5A85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 16,
    height: 6,
    rx: 2,
    fill: "#C4D7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13 h18 a4 4 0 0 1 4 4 v30 a7 7 0 0 1 -7 7 h-12 a7 7 0 0 1 -7 -7 v-30 a4 4 0 0 1 4 -4z",
    fill: "#EDF4F8",
    stroke: "#C4D7E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 24,
    height: 17,
    rx: 2,
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    width: 8,
    height: 2.5,
    rx: 1.2,
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "46 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Pocari sweat"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Drinks"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B140"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13,-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0,
    width: 12,
    height: 8,
    rx: 2.5,
    fill: "#E4813F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8 h18 a4 4 0 0 1 4 4 v35 a7 7 0 0 1 -7 7 h-12 a7 7 0 0 1 -7 -7 v-35 a4 4 0 0 1 4 -4z",
    fill: "#8FCBE8",
    stroke: "#6FAFCF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 24,
    height: 18,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 31 q7 -7 14 0",
    stroke: "#E4813F",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "31 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Gatorade 500ml"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Drinks"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B160"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19,-24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6 q6 -4 12 0 q6 4 12 0 q6 -4 12 0 v36 q-6 4 -12 0 q-6 -4 -12 0 q-6 4 -12 0z",
    fill: "#E88B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6 q6 -4 12 0 q6 4 12 0 q6 -4 12 0 v10 h-36z",
    fill: "#D9703A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 16,
    height: 3.5,
    rx: 1.75,
    fill: "#fff",
    opacity: 0.55
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "16 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Chippy"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Snacks"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B120"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0,
    width: 10,
    height: 7,
    rx: 2,
    fill: "#C8483A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7 h14 a3 3 0 0 1 3 3 v6 l2 6 v31 a6 6 0 0 1 -6 6 h-12 a6 6 0 0 1 -6 -6 v-31 l2 -6 v-6 a3 3 0 0 1 3 -3z",
    fill: "#5E3A2C",
    stroke: "#4A2C21",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#C8483A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#fff",
    opacity: 0.9
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "24 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Coke Mismo"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Drinks"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B125"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195,242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 0,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#2E9B9B",
    transform: "rotate(12 19 11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 12,
    rx: 15,
    ry: 4.5,
    fill: "#DDE5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 12 h30 l-4 38 a5 5 0 0 1 -5 4 h-12 a5 5 0 0 1 -5 -4z",
    fill: "#F2F7F8",
    stroke: "#DDE5E9",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21 h26 l-3 29 a4 4 0 0 1 -4 3 h-12 a4 4 0 0 1 -4 -3z",
    fill: "#8CC79B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 21,
    rx: 13,
    ry: 3.4,
    fill: "#B6DEBE"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "6 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Iced matcha"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Drinks"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1120"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 150,
    height: 60,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 42,
    height: 28,
    rx: 5,
    fill: "#EFC272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14 q18 -14 36 0z",
    fill: "#DFA84E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 42,
    height: 6,
    rx: 3,
    fill: "#DFA84E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 12,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    width: 12,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 5,
    width: 58,
    height: 18,
    rx: 9,
    fill: "#14344B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 17.5,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "12 Stocks"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 89,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#14344B"
  }, "Breakfast meal"), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 98,
    width: 48,
    height: 17,
    rx: 8.5,
    fill: "#E9F5F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 110,
    fontSize: 9,
    fontWeight: 600,
    fill: "#237C7C",
    textAnchor: "middle"
  }, "Foods"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 111,
    fontSize: 14,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1150"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.22b7463c1fd51bd7ef907ea1dac4d0e7.svg";
export { ForwardRef as ReactComponent };